import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Form, Button, Col, Alert } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
import './edit-leave.css';

export default function EditLeave() {
  const [leaveType, setLeaveType] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [reason, setReason] = useState('');
  const [days, setDays] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertVariant, setAlertVariant] = useState('success'); // 'success' or 'danger'
  const navigate = useNavigate();
  const { id } = useParams(); // Leave ID from the URL

  const leaveTypeOptions = [
    { value: 'Holiday', label: 'Holiday' },
    { value: 'Sick', label: 'Sick' },
    { value: 'Vacation', label: 'Vacation' },
    { value: 'Public Holiday', label: 'Public Holiday' },
    { value: 'Maternity', label: 'Maternity' },
    { value: 'Paternity', label: 'Paternity' },
    { value: 'Study Leave', label: 'Study Leave' },
    { value: 'Other Leave', label: 'Other Leave' },
  ];

  // Fetch existing leave data when the component mounts
  useEffect(() => {
    const fetchLeaveData = async () => {
      try {
        const response = await fetch(`http://localhost:5544/api/leaves/leaves/${id}`);
        const data = await response.json();

        if (response.ok && data.leave) {
          // Populate state with fetched leave data
          setLeaveType({ value: data.leave.leaveType, label: data.leave.leaveType });
          setStartDate(new Date(data.leave.startDate));
          setEndDate(new Date(data.leave.endDate));
          setReason(data.leave.reason);
          setDays(data.leave.days);
        } else {
          alert('Leave not found!');
          navigate('/leaves');
        }
      } catch (error) {
        console.error('Error fetching leave data:', error);
        alert('Error fetching leave data');
      }
    };

    fetchLeaveData();
  }, [id, navigate]);

  // Handle form submission to update the leave
  const handleSubmit = async (e) => {
    e.preventDefault();

    const updatedLeave = {
      leaveType: leaveType?.value,
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      reason,
      days,
    };

    console.log('Submitting leave update:', updatedLeave); // Debugging line

    try {
      const response = await fetch(`http://localhost:5544/api/leaves/edit-leave/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedLeave),
      });

      const data = await response.json();
      console.log('Response data:', data); // Debugging line

      if (response.ok) {
        setAlertMessage('Leave updated successfully');
        setAlertVariant('success');
        setShowAlert(true);

        // Hide the alert after 3 seconds and then redirect
        setTimeout(() => {
          setShowAlert(false); // Hide the alert
          navigate('/leaves'); // Redirect after the alert disappears
        }, 3000);
      } else {
        setAlertMessage(data.message || 'Failed to update leave');
        setAlertVariant('danger');
        setShowAlert(true);

        // Hide the alert after 3 seconds if there's an error
        setTimeout(() => {
          setShowAlert(false);
        }, 3000);
      }
    } catch (error) {
      console.error('Error updating leave:', error);
      setAlertMessage('Server error');
      setAlertVariant('danger');
      setShowAlert(true);

      // Hide the alert after 3 seconds if there's an error
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
    }
  };

  if (!leaveType || !startDate || !endDate) {
    return <div>Loading...</div>;
  }

  return (
    <div className="edit-leave-container">
      <h1 className="edit-leave-title">Edit Leave</h1>
      <hr />
      <div className="edit-leave-content">
        {showAlert && (
          <Alert variant={alertVariant} onClose={() => setShowAlert(false)} dismissible>
            {alertMessage}
          </Alert>
        )}

        <Form onSubmit={handleSubmit}>
          <Form.Group as={Col} xs={12} controlId="formGridLeaveType">
            <Form.Label>Leave Type</Form.Label>
            <Select
              options={leaveTypeOptions}
              value={leaveType}
              onChange={(selectedOption) => setLeaveType(selectedOption)}
              placeholder="--Select Leave--"
            />
          </Form.Group>

          <Form.Group as={Col} xs={12} controlId="formStartDate">
            <Form.Label>Start Date</Form.Label>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              dateFormat="MM/dd/yyyy"
              className="react-datepicker-input"
            />
          </Form.Group>

          <Form.Group as={Col} xs={12} controlId="formEndDate">
            <Form.Label>End Date</Form.Label>
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              dateFormat="MM/dd/yyyy"
              className="react-datepicker-input"
            />
          </Form.Group>

          <Form.Group as={Col} xs={12} controlId="formLeaveReason">
            <Form.Label>Reason</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="fancy-textarea"
            />
          </Form.Group>

          <Button type="submit" className="fancy-btn mt-3">
            Update Leave
          </Button>
        </Form>
      </div>
    </div>
  );
}
